<template>
  <div class="content-container">
    <!--搜索條件-->
    <a-form-model class="search-form" layout="inline" :model="searchForm">
      <!-- 帳號 -->
      <a-form-model-item
        has-feedback
        :label="$t('form.common.field.account.label')"
      >
        <a-input
          v-model="searchForm.name"
          :placeholder="$t('message.checkInputHint')"
        />
      </a-form-model-item>
      <!-- 會員等級 -->
      <a-form-model-item
              has-feedback
              :label="$t('form.common.field.level.label')"
      >
        <a-select
                v-model="searchForm.level"
                style="width: 140px"
                :placeholder="$t('member.selectLevelText')"
        >
          <a-select-option :value="0">{{$t('enum.userLevel.0')}}</a-select-option>
          <a-select-option :value="1">{{$t('enum.userLevel.1')}}</a-select-option>
          <a-select-option :value="2">{{$t('enum.userLevel.2')}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 所屬團隊 -->
      <a-form-model-item
              has-feedback
              :label="$t('form.common.field.team.label')"
      >
        <a-input
                v-model="searchForm.team_name"
                :placeholder="$t('form.common.field.team.placeholder')"
        />
      </a-form-model-item>
      <!-- 搜索按鈕 -->
      <a-form-model-item>
        <a-button type="primary" html-type="submit" @click="onSearch">{{
          $t(`actionTitles.submit`)
        }}</a-button>
        <a-button :style="{ marginLeft: '8px' }" @click="handleReset">{{
          $t(`actionTitles.clear`)
        }}</a-button>
        <!-- <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="toggle">
          {{expand ? $t('message.collapseClose'):$t('message.collapseOpen')}}
          <a-icon :type="expand ? 'up' : 'down'" />
        </a> -->
      </a-form-model-item>
    </a-form-model>
    <!--表格-->
    <div class="table-wrapper">
      <div class="opration-wrapper">
        <a-button @click="handleAdd" type="primary" icon="plus">{{
          $t(`actionTitles.create`)
        }}</a-button>
        <!-- <a-button :style="{marginLeft: '8px'}">{{$t(`message.batchOperate`)}}</a-button> -->
        <a-dropdown placement="bottomCenter">
          <a-menu
            slot="overlay"
            @click="handleChange"
            style="width: 120px; margin-left: 8px"
          >
            <a-menu-item key="delete">{{ $t("actionTitles.delete") }}</a-menu-item>
            <!-- <a-menu-item key="moveTo"> {{$t('message.moveTo')}}</a-menu-item> -->
          </a-menu>
          <a-button style="margin-left: 8px">
            {{ $t("actionTitles.moreOperate") }}
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
      <clear-selected
        alert-type="info"
        :show="selectedRowKeys.length > 0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      />

      <a-table
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :data-source="pageResult.data"
        :loading="loading"
        rowKey="id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <!--帳號-->
        <a-table-column
          key="phone"
          :title="$t('table.user.thead.account')"
          data-index="phone"
        />
        <!--暱稱-->
        <a-table-column
          key="name"
          :title="$t('table.user.thead.nickname')"
          data-index="name"
          align="center"
        />
        <!--所屬上級-->
        <a-table-column
          key="parent_name"
          :title="$t('table.user.thead.superior')"
          data-index="parent_name"
          align="center"
        />
        <!--全景作品數-->
        <a-table-column
          key="total_works"
          :sorter="true"
          :title="$t('table.user.thead.worksCount')"
          data-index="total_works"
          align="center"
        />
        <!--容量使用-->
        <a-table-column
          key="capacity"
          :sorter="true"
          :title="$t('table.user.thead.storage')"
          data-index="capacity"
          align="center"
        >
          <template slot-scope="text, record">
            <a-progress
              :percent="record.progress"
              :show-info="false"
              status="active"
            />
            <span>{{
              record.use_capacity + "G/" + record.capacity + "G"
            }}</span>
          </template>
        </a-table-column>
        <!--會員等級-->
        <a-table-column
          key="level"
          :title="$t('member.membership')"
          data-index="level"
          align="center"
        >
          <template slot-scope="text, record">{{
            $t(`enum.userLevel.${record.level}`)
          }}</template>
        </a-table-column>
        <!--過期時間-->
        <a-table-column
          key="expire_time"
          :title="$t('table.common.thead.expireTime')"
          data-index="expire_time"
          align="center"
        >
          <template slot-scope="text, record">{{
            record.level == 0 ? '--' : record.expire_time
          }}</template>
        </a-table-column>
        <!--平台推薦-->
        <a-table-column
          key="recommend"
          :title="$t('table.common.thead.recommend')"
          :sorter="true"
          data-index="recommend"
          align="center"
        >
          <template slot-scope="text, record">
            <a-icon
              v-if="record.recommend == 0"
              @click="recommend(record)"
              style="color: red"
              type="close"
            />
            <a-icon
              v-else
              style="color: green"
              @click="recommend(record)"
              type="check"
            />
          </template>
        </a-table-column>
        <!--全景配置權-->
        <a-table-column
          key="is_authority"
          :title="$t('table.user.thead.panoConfigPower')"
          data-index="is_authority"
          align="center"
        >
          <template slot-scope="text, record">
            <a
              v-if="record.is_authority == 0"
              @click="authorityChange(record)"
              style="color: red"
              >{{ $t(`enum.authority.${record.is_authority}`) }}</a
            >
            <a v-else style="color: #1890ff" @click="authorityChange(record)">{{
              $t(`enum.authority.${record.is_authority}`)
            }}</a>
          </template>
        </a-table-column>
        <!--操作按鈕-->
        <a-table-column key="operate" :title="$t('table.common.thead.operate')">
          <template slot-scope="text, record">
            <span>
              <a @click="resetPassword(record.id)">{{
                $t("login.resetPassword")
              }}</a>
              <a-divider type="vertical" />
              <a @click="detail(record)">{{ $t("actionTitles.detail") }}</a>
              <a-divider type="vertical" />
              <a @click="config(record.id)">{{ $t("actionTitles.config") }}</a>
              <a-divider type="vertical" />
              <a @click="viewWork(record.id)">{{ $t("actionTitles.viewWork") }}</a>
              <a-divider type="vertical" />
              <a-popconfirm
                placement="top"
                :ok-text="$t('actionTitles.yes')"
                :cancel-text="$t('actionTitles.no')"
                @confirm="handleDelete(record.id)"
              >
                <template slot="title">{{ $t("message.delUser") }}</template>
                <a style="color: red">{{ $t("actionTitles.delete") }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <!--重置密碼-->
    <a-modal
      v-model="updatePasswordModel"
      :title="$t('login.resetPassword')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="updatePassword"
    >
      <a-form-model
        ref="updatePasswordForm"
        layout="vertical"
        :form="updatePasswordForm"
        :rules="passwordRules"
        :model="updatePasswordForm"
      >
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.password.label')"
          prop="password"
        >
          <a-input-password
            v-model="updatePasswordForm.password"
            :placeholder="$t('form.common.field.password.message')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--編輯彈窗 -->
    <a-modal
      v-model="exitVisible"
      :title="$t('moduleTitles.addUser')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="handleSave"
      width="740px"
    >
      <a-form-model
        ref="ruleForm"
        layout="horizontal"
        :form="form"
        :rules="rules"
        :model="form"
        v-bind="layout"
      >
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.mobile.label')"
          prop="phone"
        >
          <a-input
            v-model="form.phone"
            :placeholder="
              $t('form.common.field.mobile.message') + $t('message.phoneHint')
            "
          />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.password.label')"
          prop="password"
        >
          <a-input-password
            v-model="form.password"
            :placeholder="$t('form.common.field.password.message')"
          />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.user.field.dealer.label')"
        >
          <a-select
            :showSearch="true"
            :allowClear="true"
            v-model="form.pid"
            abel-in-value
            :default-value="{ key: 0 }"
            :placeholder="$t('form.user.field.dealer.message')"
          >
            <a-select-option
              v-for="(item, index) in dealerList"
              :key="index"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.user.field.store_type.label')"
          :placeholder="$t('form.user.field.store_type.message')"
        >
          <a-select 
            v-model="form.store_type"
            :placeholder="$t('form.user.field.store_type.message')"
          >
            <a-select-option :value="1">{{ $t("enum.store_type[1]") }}</a-select-option>
            <a-select-option :value="2">{{ $t("enum.store_type[2]") }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.user.field.store_id.label')"
        >
          <a-input
            v-model="form.store_id"
            :placeholder="$t('form.user.field.store_id.message')"
          />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.user.field.nickname.label')"
          prop="name"
        >
          <a-input
            v-model="form.name"
            :placeholder="$t('form.user.field.nickname.message')"
          />
        </a-form-model-item>

        <a-form-model-item
          has-feedback
          :label="$t('form.user.field.linkman.label')"
          prop="linkman"
        >
          <a-input
            v-model="form.linkman"
            :placeholder="$t('form.user.field.linkman.message')"
          />
        </a-form-model-item>

        <!-- <a-form-model-item
          has-feedback
          :label="$t('form.user.field.childLimit.label')"
          prop="child_limit"
        >
          <a-input-number v-model="form.child_limit" :placeholder="$t('form.user.field.childLimit.message')"/>
        </a-form-model-item> -->

        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.gender.label')"
        >
          <a-radio-group v-model="form.gender">
            <a-radio :value="1">{{ $t("enum.gender.male") }}</a-radio>
            <a-radio :value="0">{{ $t("enum.gender.female") }}</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.area.label')"
        >
          <h-region-select
            @regionData="selectedData"
            :defaultValue="defaultValue"
          ></h-region-select>
        </a-form-model-item>

        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.briefIntroduction.label')"
        >
          <a-textarea
            v-model="form.brief"
            :placeholder="$t('form.common.field.briefIntroduction.placeholder')"
            allow-clear
          />
        </a-form-model-item>

        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.address.label')"
          prop="address"
        >
          <a-textarea
            v-model="form.address"
            :placeholder="$t('form.common.field.address.message')"
            allow-clear
          />
        </a-form-model-item>

        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.wechat.label')"
        >
          <a-input
            v-model="form.wechat"
            :placeholder="$t('form.common.field.wechat.message')"
          />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.email.label')"
          prop="email"
        >
          <a-input
            v-model="form.email"
            :placeholder="$t('form.common.field.email.message')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>


<script>
import ClearSelected from "../../components/ClearSelected";
import {
  pageQuery,
  dealerQueryAll,
  createUser,
  softDelete,
  changeAuthority,
  recommend,
  resetPassword,
} from "@/api/user";
import HRegionSelect from "@/components/HRegionSelect";
import moment from "moment";
import { validatephone } from "@/utils/validate";

export default {
  components: { ClearSelected, HRegionSelect },

  data() {
    let phoneCheck = (rule, value, callbackFn) => {
      // const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!validatephone(value)) {
        callbackFn(this.$t("form.common.field.phone.checkMessage"));
        return;
      }
      callbackFn();
    };
    return {
      pid: 0,
      loading: true,
      layout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 },
      },
      searchForm: {},
      expand: false,
      form: {
        phone: "",
        name: "",
        linkman: "",
        address: "",
        gender: 1,
        store_id: '',
        store_type: 0,
      },
      pageResult: [],
      selectedRowKeys: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      filters: [
        { text: this.$i18n.t("enum.expireStatus.0"), value: "0" },
        { text: this.$i18n.t("enum.expireStatus.1"), value: "1" },
      ],
      exitVisible: false,
      rules: {
        phone: [
          {
            required: true,
            message: this.$t("form.common.field.phone.message"),
            trigger: "blur",
          },
          { validator: phoneCheck, trigger: "blur" },
        ],
        name: [
          {
            required: true,
            message: this.$t("form.user.field.nickname.message"),
            trigger: "blur",
          },
        ],
        linkman: [
          {
            required: true,
            message: this.$t("form.user.field.linkman.message"),
            trigger: "blur",
          },
        ],
        // child_limit:[
        //   {
        //     required: true,
        //     message: this.$t("form.user.field.childLimit.message"),
        //     trigger: "blur",
        //   },
        // ],
        address: [
          {
            required: true,
            message: this.$t("form.common.field.address.message"),
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email",
            message: this.$t("form.userDetail.form.field.email.checkMessage"),
            trigger: "blur",
          },
        ],
      },
      defaultValue: [],
      dealerList: [],
      passwordRules: {
        password: [
          {
            required: true,
            message: this.$t("form.common.field.password.message"),
            trigger: "blur",
          },
        ],
      },
      updatePasswordModel: false,
      updatePasswordForm: {
        id: 0,
        password: "",
      },
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    },
  },
  updated() {
    console.log("updated");
  },
  mounted() {
    this.pid = this.$route.params?.pid || 0;
    this.searchForm.team_name = this.$route.params && this.$route.params.team_name ? this.$route.params.team_name : ''
    this.loadData();
    dealerQueryAll().then((res) => {
      this.dealerList = res.data;
    });
  },
  methods: {
    resetPassword(userId) {
      this.updatePasswordModel = true;
      this.updatePasswordForm = { ...{ id: userId, password: "" } };
      setTimeout(() => {
        this.$refs["updatePasswordForm"].resetFields();
      }, 0);
    },
    updatePassword() {
      this.$refs.updatePasswordForm.validate((valid) => {
        if (valid) {
          resetPassword(this.updatePasswordForm).then((res) => {
            this.$message.success(this.$t("message.saveSuccess"));
            this.updatePasswordModel = false;
          });
        }
      });
    },
    recommend(record) {
      let userType = this.$store.getters.userInfo.type;
      if (userType == 1) {
        let userInfo = { id: record.id };
        userInfo.recommend = record.recommend == 1 ? 0 : 1;
        recommend(userInfo).then((res) => {
          this.loadData();
        });
      }
    },
    authorityChange(record) {
      let is_authority = record.is_authority == 1 ? 0 : 1;
      changeAuthority({ id: record.id, is_authority: is_authority }).then(
        (res) => {
          this.loadData();
        }
      );
    },
    onSearch() {
      this.pagination.current = 1;
      this.loadData();
    },
    //數據加載
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchForm,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
          pid: this.pid,
        },
      };
      pageQuery(this.searchParam)
        .then((res) => {
          this.loading = false;
          this.pageResult = res.data;
          this.pagination.total = res.data.total;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //table 翻頁
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";

        let order = {};
        order[field] = orderStr;
        this.searchForm.order = order;
      }
      this.loadData();
    },
    handleAdd() {
      this.exitVisible = true;
      setTimeout(() => {
        this.exitModelRest();
      }, 0);
    },
    handleSave() {
      console.log(this.form);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.form.username = this.form.phone;
          createUser(this.form).then((res) => {
            this.loadData();
            this.$message.success(this.$t("message.saveSuccess"));
            this.exitVisible = false;
          });
        }
      });
    },
    handleDelete(id) {
      let ids = [id];
      this.delete(ids);
    },
    delete(ids) {
      softDelete({ id: ids }).then((res) => {
        this.loadData();
        this.$message.success(this.$t("message.deleteSuccess"));
      });
    },
    handleChange(val) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$i18n.t("message.selectHint"));
        return;
      }
      if (val.key == "delete") {
        this.delete(this.selectedRowKeys);
      }
    },
    detail(record) {
      this.$router.push({
        path: "/admin/user/detail",
        query: { userId: record.id },
      });
    },
    config(userId) {
      this.$router.push({
        path: "/admin/user/config",
        query: { userId },
      });
    },
    handleReset() {
      this.searchForm = {};
      this.pagination.current = 1;
      this.loadData();
    },
    exitModelRest() {
      this.form = {
        gender: 1,
        g_capacity: 20,
        expire_time: moment().add(1, "year"),
      };
      this.$refs["ruleForm"].resetFields();
    },
    selectedData(val) {
      this.form.region = val;
    },
    toggle() {
      this.expand = !this.expand;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
    },
    viewWork(uid) {
      this.$router.push({ path: "/admin/workManage/workList", query: { uid } });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
